import React, { useContext } from "react";
import styles from "./Cover.module.scss";
import PathContext from "../../context/path";
const Cover = () => {
  const path = useContext(PathContext);
  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.img}>
          <picture>
            <source media="(max-width: 767px)" srcSet={`${path}/img/main-mobile.webp`} />
            <img src={`${path}/img/main.webp`} alt="" />
          </picture>
        </div>
        <div className={styles.info}>
          <h1 className={styles.title}>Как из 13 страниц регламентов сделать понятную историю о правилах общения в компании</h1>
          <div className={styles.desc}>Проект для сотрудников<br /> ПАО «Северсталь»</div>
        </div>
      </div>
    </>
  );

}

export default Cover;
